import { t } from '@lingui/macro';
import * as yup from 'yup';

const validationSchema = yup
  .object({
    id: yup
      .string()
      .required(t`Depot ID is required`)
      .matches(
        /^[a-zA-Z0-9]+$/,
        t`Depot ID can only contain alphanumeric characters`,
      )
      .max(10),
    name: yup.string().required(t`Name is required`),
    email: yup
      .string()
      .email()
      .required(t`Email is required`),
    address: yup.string(),
    city: yup.string().required(t`City is required`),
    state: yup.string().required(t`State is required`),
    postalCode: yup.string(),
    country: yup.string().required(t`Country is required`),
  })
  .required();

export default validationSchema;
